import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Box, Theme, useTheme } from '@mui/material';

import { useUser } from '@/modules/common/application/context/user';

import DrawerBottom from './DrawerBottom';
import DrawerHead from './DrawerHead';
import DrawerMenu from './DrawerMenu';
import { getToggleButtonStyles } from './styles';

interface Props {
  drawerExpanded: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  toggleDrawer: any;
}

const ToggleButton = ({ toggleDrawer, drawerExpanded }: Props) => {
  const theme = useTheme() as Theme;
  return (
    <Box
      onClick={toggleDrawer}
      sx={getToggleButtonStyles(theme, drawerExpanded)}
      data-cy="action-toggle-menu"
    >
      <ChevronLeftIcon
        color="inherit"
        sx={{
          position: 'relative',
          fontSize: '1.6rem',
          color: 'text.secondary',
        }}
        data-cy="action-toggle-menu-icon"
      />
    </Box>
  );
};

const DrawerContent = ({ drawerExpanded, toggleDrawer }: Props) => {
  const handleClick = () => toggleDrawer();
  const { hasCompleteProfile, hasCompanyOnboarded } = useUser();

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflow: 'hidden',
        backgroundColor: 'white',
      }}
    >
      <ToggleButton toggleDrawer={handleClick} drawerExpanded={drawerExpanded} />
      <DrawerHead drawerExpanded={drawerExpanded} />
      {hasCompleteProfile && hasCompanyOnboarded && <DrawerMenu drawerExpanded={drawerExpanded} />}
      <DrawerBottom drawerExpanded={drawerExpanded} />
    </Box>
  );
};

export default DrawerContent;
